import { setUser } from "../../store/slices/common-slice";
import { changePassword } from "../../store/actions/user-action";
import { AppDispatch, RootState } from "@/store/store";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default () => {
  const dispatch: AppDispatch = useDispatch()
  const navigate = useNavigate();

  const { user } = useSelector((state: RootState) => state.common);
  const { user_loading } = useSelector((state: RootState) => state.user);


  const [open, setOpen] = useState(false)

  const onSubmit = (values: any, resetForm: () => void) => {

    const api_data = {
      "oldPassword": values?.oldPassword,
      "newPassword": values?.newPassword
    }
    dispatch(changePassword(api_data, () => {
      resetForm()
      dispatch(setUser(null));
      navigate('/login');

    }))
  }

  return {
    user,
    setOpen,
    open,
    user_loading,
    onSubmit

  };
}